const blogCategories = [
  "product",
  "sales",
  "business",
  "crm",
  "marketing",
  "culture",
  "webinars",
]

module.exports = blogCategories
